import { collection, addDoc, serverTimestamp, query, where, getDocs, writeBatch, doc } from 'firebase/firestore';
import { db } from '../firebase';

export const sendNotification = async (userId, title, message, type = 'info', link = null) => {
  try {
    await addDoc(collection(db, 'notifications'), {
      userId,
      title,
      message,
      type, // 'info', 'success', 'warning'
      isRead: false,
      link,
      createdAt: serverTimestamp()
    });
  } catch (err) {
    console.error("Error sending notification:", err);
  }
};

export const notifyAdmins = async (title, message, type = 'info', link = null) => {
  try {
    const q = query(collection(db, 'users'), where('role', '==', 'admin'));
    const snap = await getDocs(q);
    
    if (snap.empty) return;
    
    const batch = writeBatch(db);
    snap.docs.forEach((adminDoc) => {
      const newNotifRef = doc(collection(db, 'notifications'));
      batch.set(newNotifRef, {
        userId: adminDoc.id,
        title,
        message,
        type,
        isRead: false,
        link,
        createdAt: serverTimestamp()
      });
    });
    
    await batch.commit();
  } catch (err) {
    console.error("Error notifying admins:", err);
  }
};
